import { useCallback, useReducer, useRef } from 'react';

const ACTIONS = {
  ADD: 'ADD',
  REMOVE_FIRST: 'REMOVE_FIRST',
  CLEAR: 'CLEAR',
};

const initialState = [];

const reducer = (state, { type, payload }) => {
  switch (type) {
    case ACTIONS.ADD:
      return state.includes(payload) ? state : [...state, payload];
    case ACTIONS.REMOVE_FIRST:
      return state.slice(1);
    case ACTIONS.CLEAR:
      return [];
    default:
      return state;
  }
};
/**
 * Hook to manage a queue of requests
 * @param {Function} processItem - Function to process a queued item
 * @returns {object} - Queue management interface
 */
const useQueue = (processItem) => {
  const [queue, setQueue] = useReducer(reducer, initialState);

  const isProcessingRef = useRef(false);

  const addToQueue = useCallback((item) => {
    setQueue({ type: ACTIONS.ADD, payload: item });
  }, []);

  const clearQueue = useCallback(() => {
    setQueue({ type: ACTIONS.CLEAR });
  }, []);

  const processQueue = useCallback(async () => {
    if (queue.length === 0 || isProcessingRef.current) return;

    isProcessingRef.current = true;

    try {
      const item = queue[0];
      await processItem(item);
    } finally {
      setQueue({ type: ACTIONS.REMOVE_FIRST });
      isProcessingRef.current = false;
    }
  }, [queue, processItem]);

  return {
    queue,
    isEmpty: queue.length === 0,
    addToQueue,
    clearQueue,
    processQueue,
  };
};

export default useQueue;
